import React, { useEffect } from "react";
import Loader from "../Loader";

const TabPanel = (props) => {
    const [loading, setLoading] = React.useState(props.loading || false);
    const { children, value, name } = props;

    useEffect(() => {
        setLoading(props.loading || false);
    }, [props.loading]);

    return (
        value === name && (
            !loading ?
                <div
                    className="tab-content content-height"
                    id={`class-tabpanel-${name}`}
                    aria-labelledby={`class-tab-${name}`}
                    key={`tabpanel-${name}`}>
                    {children}
                </div>
                :
                <Loader loading={true} />
        )

    );
};

export default TabPanel;